import React from 'react';

export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50, 100];

function ListingPagination({ page, pageSize, total, onPageChange, onPageSizeChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const firstItem = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const lastItem = Math.min(safePage * pageSize, total);

  return <div className="listing-pagination" aria-label="Table pagination">
    <span>Showing {firstItem}-{lastItem} of {total}</span>
    <div className="listing-pagination-controls">
      <button type="button" className="listing-pagination-arrow" onClick={() => onPageChange(safePage - 1)} disabled={safePage === 1} aria-label="Previous page">←</button>
      <strong>Page {safePage} of {totalPages}</strong>
      <button type="button" className="listing-pagination-arrow" onClick={() => onPageChange(safePage + 1)} disabled={safePage === totalPages} aria-label="Next page">→</button>
      <label className="listing-page-size"><span>Items per page</span><select value={pageSize} onChange={event => onPageSizeChange(Number(event.target.value))}>
        {PAGE_SIZE_OPTIONS.map(size => <option key={size} value={size}>{size}</option>)}
      </select></label>
    </div>
  </div>;
}

export default ListingPagination;
